import * as Highcharts from 'highcharts';
import { find, get } from 'lodash';

import { formatParameters, IFormatOutputParameters } from '../../../../../Visualization/formatParameters';
import { truncationValues } from '../../../../../Visualization/visualizationConstants';

import { FormatConfig } from './types';

/**
 * Get format configuration based on format key
 */
export const getFormatConfig = (formatKey: number | null | undefined): FormatConfig => {
  const formatParams = find(formatParameters, { formatKey }) as IFormatOutputParameters;
  
  if (!formatParams) {
    return {
      decimalPlaces: 0,
      formatType: '',
      prefix: '',
      suffix: '',
      magnitudeTruncation: 0,
    };
  }
  
  const numberType = get(formatParams, 'numberType', '');
  
  return {
    decimalPlaces: get(formatParams, 'decimalPlaces', 0),
    formatType: numberType,
    prefix: numberType === '$' ? '$' : '',
    suffix: numberType === 'Percent' ? '%' : '',
    magnitudeTruncation: get(formatParams, 'magnitudeTruncation', 0),
  };
};

/**
 * Format a numeric value based on format configuration
 */
export const formatValue = (value: number, formatConfig: FormatConfig): string => {
  const { formatType, prefix, suffix, decimalPlaces, magnitudeTruncation } = formatConfig;
  const adjustedValue = (formatType === 'Percent' ? value * 100 : value) /
    truncationValues[magnitudeTruncation.toString()];
  
  return `${prefix}${Highcharts.numberFormat(adjustedValue, decimalPlaces, '.')
    .toString()
    .replaceAll(' ', '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${suffix}`;
};